<div class="carousel">
    <ng-container *msComponentProxy="marqueeComponent"> </ng-container>
</div>
